import { Injectable, inject } from '@angular/core';

import { BottomNavService as CoreBottomNavService, DynamicLayoutService, OnFeatureInit, SlotName } from '@frontend/vanilla/core';
import { SpeculationService } from '@frontend/vanilla/core';
import { firstValueFrom, switchMap, take } from 'rxjs';

import { BottomNavConfig } from './bottom-nav.client-config';
import { BottomNavComponent } from './bottom-nav.component';
import { BottomNavService } from './bottom-nav.service';

@Injectable()
export class BottomNavBootstrapService implements OnFeatureInit {
    private config = inject(BottomNavConfig);
    private dynamicLayoutService = inject(DynamicLayoutService);
    private coreBottomNavService = inject(CoreBottomNavService);
    private bottomNavService = inject(BottomNavService);
    private speculationService = inject(SpeculationService);

    async onFeatureInit() {
        await firstValueFrom(this.config.whenReady);
        this.coreBottomNavService.set(this.bottomNavService);
        this.dynamicLayoutService.addComponent(SlotName.App, BottomNavComponent, null);
        this.bottomNavService.initProductHighlighting();

        if (!this.bottomNavService.currentHighlightedProductName) {
            this.bottomNavService.setHighlightedProduct();
        }

        this.speculationService.whenReady
            .pipe(
                switchMap(() => this.bottomNavService.evaluatedItems$),
                take(1),
            )
            .subscribe((items) => this.speculationService.prerender(items.map((item) => item.url)));
    }
}
